export default {"src":"/_next/static/media/play-store.ecd428c5.svg","height":53,"width":180,"blurWidth":0,"blurHeight":0};